module.exports = "https://trybtryb-legacy.web.app/img/growth_team_thin.f97ed7ec.svg";